import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// COMPONENTS
import { AgGridModule } from 'ag-grid-angular';

import { MaterialCustomModule } from 'v2/material-custom.module';
import { PipeModule } from 'v2/modules/shared/pipes/pipe.module';

import { DirectiveModule } from '../shared/directives/directive.module';
import { UiModule } from '../ui/ui.module';

import {
  CompanyAutocompleteComponent,
  CompanyShippingAddressesComponent,
} from './components';

// MODULES

import { CompanyShippingAddressDropdownActionCellRendererComponent } from './components/company-shipping-address-dropdown-action-cell-renderer/company-shipping-address-dropdown-action-cell-renderer.component';

const angularModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
];

const lumModules = [PipeModule, MaterialCustomModule, UiModule, DirectiveModule];

const libModules = [AgGridModule];

const components = [
  CompanyAutocompleteComponent,
  CompanyShippingAddressesComponent,
];

@NgModule({
  declarations: [
    ...components,
    CompanyShippingAddressDropdownActionCellRendererComponent,
  ],
  imports: [...angularModules, ...lumModules, ...libModules],
  exports: [...components],
})
export class CompanyModule {}
